import Button from '../../common/Button'
import ModalWrapper from '../../common/Modal/ModalWrapper'

const InvestorMatchDisclaimer = ({ handleClose }) => {
    return (
        <ModalWrapper
            modalType={'investorMatchDisclaimer'}
            modalCardClasses={'maw900px'}
            onCloseHandler={handleClose}
        >

            <div>
                <h3 className='c15 tac fs1-5rem'>Disclaimer</h3>

                <div
                    style={{
                        maxWidth: '80%',
                        margin: '1rem auto 2rem',
                    }}
                >
                    <p className='c15 mb1rem fs13px'>Before You Continue:</p>
                    <ul>
                        <li className='c15 mb0-5rem fs13px'>
                            <span className='fw600'>No investment advice. </span>
                            Diligentsia provides tools for companies to initiate matches with investors — not financial advice.
                        </li>
                        <li className='c15 mb0-5rem fs13px'>
                            <span className='fw600'>No liaibility. </span>
                            Diligentsia is not liable for accuracy of information supplied by any party on the platform
                        </li>
                        <li className='c15 mb0-5rem fs13px'>Are you a
                            <span className='fw600'> company? </span> Always seek professional investment advice.
                        </li>
                        <li className='c15 mb0-5rem fs13px'>Are you an
                            <span className='fw600'> investor? </span>
                            Diligentsia’s self-diligence info is company-created and unaudited. We’re not liable for its content.
                        </li>
                        <li className='c15 mb0-5rem fs13px'>
                            <span className='fw600'>No commsssion. </span>
                            Diligentsia is not paid by investors or third parties as part of the matching process.
                        </li>
                        <li className='c15 mb0-5rem fs13px'>No involvement post match.</li>
                    </ul>
                </div>

                <h3 className='c15 tac'>Happy with this?</h3>

                {/* <div className='pr'>
                    <img
                        className='pa'
                        src={require('../../../../images/investor-dashboard/investorMatchDisclaimer.png')}
                        alt='clarenceIcon'
                        style={{
                            right: 0,
                            top: '-90px',
                            maxWidth: '300px'
                        }}
                    />
                </div> */}

                <div
                    className='df jcc'
                >
                    <Button
                        style={{ width: '250px' }}
                        customClassName='mt1rem'
                        text={'Next'}
                        onClick={handleClose}
                        btnType='warning'
                    />
                </div>

                <p className='c15 fs11px ttj op60 mt1rem'
                    style={{
                        maxWidth: '80%',
                        margin: '1rem auto',
                    }}
                >
                    InvestorMatch information on the Diligentsia Platform, supplied by an applicant company or an investor, has not been reviewed, approved, or endorsed by Diligentsia and may contain inaccuracies, omissions, or outdated information. The content is provided for general informational purposes only. It does not constitute investment advice, a financial promotion, or a recommendation, and should not be relied upon in connection with any investment decision. Diligentsia Limited is not authorised or regulated by the Financial Conduct Authority (FCA), and InvestorMatch is not regulated under the Financial Services and Markets Act 2000 (FSMA). No reliance should be placed on the accuracy or completeness of this information by any party, including companies seeking funding, advisors, or other event attendees. Neither Diligentsia Limited, its employees or agents accept any responsibility or liability for any loss or damage arising from use of or reliance on this feature. Users are strongly encouraged to conduct their own due diligence and verify all information received or provided.
                </p>
            </div>
        </ModalWrapper>
    )
}

export default InvestorMatchDisclaimer